import axios from "axios";

// constants
import { BASE_URL } from "src/utils/constants";

export const getBlogList = () => {
  let data = {
    IsFromWeb: true,
    PageNumber: 1,
    PageSize: 10,
  };

  const response = axios({
    method: "post",
    // url: `${BASE_URL()}/Blogs`,
    url: `https://m.eventmoon.com/api/Blogs`,
    data: data,
  });

  return response;
};
